
import React from "react";

interface LogoProps {
  variant?: "full" | "icon-only";
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  isWhite?: boolean;
}

export const Logo: React.FC<LogoProps> = ({ 
  variant = "full", 
  className = "", 
  size = "md",
  isWhite = false 
}) => {
  // Definiere Größen für die verschiedenen Varianten
  const sizeClasses = {
    sm: variant === "full" ? "h-6" : "h-6",
    md: variant === "full" ? "h-10" : "h-8",
    lg: variant === "full" ? "h-16" : "h-12",
    xl: variant === "full" ? "h-38" : "h-24",  // Changed from h-42 to h-38
  };

  const logoUrl = isWhite 
    ? "/lovable-uploads/a436215d-652d-4f4a-b003-7950e32305b2.png" 
    : "/lovable-uploads/df5d4a15-b764-48c8-93e7-2adbf679ef2c.png";

  return (
    <div className={`flex items-center ${className}`}>
      <img
        src={logoUrl}
        alt="Hoss Immo Consulting Logo"
        className={`${sizeClasses[size]} object-contain`}
      />
    </div>
  );
};
